/**
 * @generated SignedSource<<5d8e7c9f9627d3812a55cc4722b12aa2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LegalContractMutationGroup",
    "kind": "LinkedField",
    "name": "legalContract",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "value"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "LegalContractTermModifyPayload",
        "kind": "LinkedField",
        "name": "modifyTerm",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LegalContractTerm",
            "kind": "LinkedField",
            "name": "legalContractTerm",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditContractTermModal_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditContractTermModal_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "db6bcd36081808832b0ad992cbf3e819",
    "id": null,
    "metadata": {},
    "name": "EditContractTermModal_Mutation",
    "operationKind": "mutation",
    "text": "mutation EditContractTermModal_Mutation(\n  $id: ID!\n  $value: String!\n) {\n  legalContract {\n    modifyTerm(input: {id: $id, value: $value}) {\n      legalContractTerm {\n        id\n        value\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "4eed731465472706a24618595390ac42";

export default node;
